var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderGreyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/folder-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3337 9.1665V14.1665C18.3337 17.4998 17.5003 18.3332 14.167 18.3332H5.83366C2.50033 18.3332 1.66699 17.4998 1.66699 14.1665V5.83317C1.66699 2.49984 2.50033 1.6665 5.83366 1.6665H7.08366C8.33366 1.6665 8.60866 2.03317 9.08366 2.6665L10.3337 4.33317C10.6503 4.74984 10.8337 4.99984 11.667 4.99984H14.167C17.5003 4.99984 18.3337 5.83317 18.3337 9.1665Z",
    fill: "white",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.66699 1.6665H14.167C15.8337 1.6665 16.667 2.49984 16.667 4.1665V5.3165",
    stroke: "#566875",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderGreyIcon);
export default __webpack_public_path__ + "static/media/folder-grey-icon.fc8737a527c2cede466783b7238b5d08.svg";
export { ForwardRef as ReactComponent };